document.addEventListener('DOMContentLoaded', function() {
    // 選考会結果通知の作成・編集画面のみ処理する
    const branchInput = document.getElementById('screening-branch-input');
    if (!branchInput) return;

    const branchIdHidden = document.getElementById('screening-branch-id');
    const branchOptions = document.querySelectorAll('#screening_branches_list option');

    // 支部名からIDを取得するマップを作成
    const branchMap = {};
    branchOptions.forEach(option => {
        branchMap[option.value] = option.dataset.id;
    });

    // 入力された支部名に対応するIDを hidden にセットする（一致しない場合は空にして必須エラーにする）
    const syncBranchId = function() {
        branchIdHidden.value = branchMap[branchInput.value] || '';
    };

    branchInput.addEventListener('input', syncBranchId);
    branchInput.addEventListener('change', syncBranchId);
});
